<template>
  <div class="ml-2 mb-3">
    <v-file-input
        id="imageInput"
        accept="image/png, image/jpeg,image/jpg"
        style="display: none"
        @change="setImage"
        filled
        required
        multiple
    ></v-file-input>
    <HeaderOrders
        :arrow="true"
        :title="courseId ? 'Editar curso': 'Editar curso'"
        :text="courseId ? 'Editar curso': 'Cadastrar curso'"
        :haveAction="true"
        actionTitle="Novo Pedido"
        @voltar="goToRoute('/cursos')"
    >
    </HeaderOrders>

    <v-dialog
        v-model="dialogvideo"
        max-width="800px"
    >
      <v-card>
        <v-card-title class="   " >
          <h3 class="pb-3">Adicionar vídeo</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Cole o código HTML de incorporação (embed) do YouTube. Para obter esse código, abra o vídeo no YouTube, <br/>clique em ‘Compartilhar’, selecione ‘Incorporar’ e copie o código exibido.
        </v-card-text>

        <v-textarea
            outlined
            :rules="[rules.required]"
            hide-details
            placeholder="Cole o código de incorporação (embed) do YouTube aqui"
            style="border: 1px solid #979797; border-radius: 7.5px"
            color="black"
            background-color="#F5F5F5"
            class="mx-5"
            rows="3"
            v-model="embeddedVideo"
        ></v-textarea>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="dialogvideo = false"
          >
            Cancelar
          </v-btn>
          <v-btn
              color="green"
              text
              :disabled="!embeddedVideo"
              @click="addVdeo()"
          >
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card elevation="1">
      <v-container
          style="max-width: unset"
          class="pa-1 pt-1 ma-0"
      >
        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <span class="photo-field ml-1">
                Fotos
                <strong style="color: #bc0000">*</strong>
              </span>

            <div class="div-images d-flex mt-2">
              <draggable
                  class="list-group"
                  tag="div"
                  ghost-class="ghost"
                  v-model="course.images"
                  v-bind="dragOptions"
                  @start="drag = true"
                  @end="drag = false"
              >
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                  <div
                      class="list-group-item d-inline-flex align-center"
                      v-for="(image, index) in course.images"
                      :key="index"
                  >
                    <div class="text-center">
                      <v-hover v-slot="{ hover }">
                        <v-img
                            :src="image.path"
                            :style="index === 0 || hover
                                ? 'border: 2px solid #BC0000; border-radius: 5px !important; cursor: pointer'
                                : 'border-radius: 5px !important; opacity: .7; cursor: pointer'"
                            width="150"
                            height="150"
                            :class="hover ? 'elevation-6 mx-2' : 'mx-2'"
                        >
                        </v-img>
                      </v-hover>

                      <p class="delete-photo" @click="deleteImage(image.uid)">
                        Excluir
                      </p>
                    </div>
                  </div>
                </transition-group>
              </draggable>

              <div class=" ">
                <v-hover v-slot="{ hover }">
                  <div
                      class="image-container mx-2"
                      :style="hover ? 'border: 2px solid #BC0000' : ''"
                      @click="openPicker"
                  >
                    <v-img
                        src="../../../../assets/plus.svg"
                        contain
                        max-width="37"
                        height="33"
                    >
                    </v-img>
                  </div>
                </v-hover>

                <p class="image-field mt-2 mb-0">Adicionar foto</p>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <span class="photo-field ml-1">
                Vídeos
              </span>

            <div v-if="showVideos" class="div-images d-flex mt-2">
              <draggable
                  class="list-group"
                  tag="div"
                  ghost-class="ghost"
                  v-model="course.videos"
                  v-bind="dragOptionsVideos"
                  @start="dragVideo = true"
                  @end="dragVideo = false"
              >
                <transition-group type="transition" :name="!dragVideo? 'flip-list' : null">
                  <div
                      class="list-group-item d-inline-flex align-center"
                      v-for="(video, i) in course.videos"
                      :id="video.uid"
                      :key="i"
                  >
                    <div class="text-center">
                      <v-hover v-slot="{ hover }">
                        <p
                            :key="video.uid"
                            class="image-container"
                            v-html="video.htmlEmbed"
                            :style="i === 0 || hover
                                ? 'border: 2px solid #BC0000; border-radius: 5px !important; cursor: pointer'
                                : 'border-radius: 5px !important; opacity: .7; cursor: pointer; width'"
                            :class="hover ? 'elevation-6 mx-2' : 'mx-2'"
                        >
                        </p>
                      </v-hover>

                      <a class="delete-photo" @click="deleteVideo(video.uid)">
                        Excluir
                      </a>
                    </div>
                  </div>
                </transition-group>
              </draggable>

              <div class="align-center">
                <v-hover v-slot="{ hover }">
                  <div
                      class="image-container mx-2"
                      :style="hover ? 'border: 2px solid #BC0000' : ''"
                      @click="showModalAddVideos"
                  >
                    <v-img
                        src="../../../../assets/plus.svg"
                        contain
                        max-width="37"
                        height="33"
                    >
                    </v-img>
                  </div>
                </v-hover>

                <p class="image-field mt-2">Adicionar vídeo <br/> do Yotube</p>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-form ref="courseForm" v-model="courseForm" lazy-validation>
          <v-row cols="12" class="ma-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Nome</label>
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Nome do curso"
                  v-model="course.name"
                  attach
                  dense
                  :rules="[rules.required]"
                  color="#000000"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Descrição</label>
              <v-textarea
                  hide-details
                  outlined
                  placeholder="Descrição do curso"
                  v-model="course.description"
                  attach
                  dense
                  rows="2"
                  :rules="[rules.required]"
                  color="#000000"
              >
              </v-textarea>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Categorias/Subcategorias</label>
              <v-select
                  color="black"
                  v-model="categoriesCoursesSelected"
                  clearable
                  attach
                  :items="categoriesCourses"
                  outlined
                  append-icon="mdi-chevron-down"
                  required
                  placeholder="Categorias/Subcategorias"
                  dense
                  item-text="name"
                  item-value="id"
                  :rules="[rules.required]"
                  multiple
                  hide-details
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      color="#bc0000"
                      class="my-1"
                  >
                    <span style="color: #FFFFFF; font-size: 14px">{{ item.name }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Sobre o Curso</label>
              <quill-editor
                  :content="course.aboutTheCourse"
                  ref="aboutTheCourse"
                  @change="onEditorChangeAboutTheCourse($event)"
              >
              </quill-editor>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label>Pré-requisitos</label>
              <quill-editor
                  :content="course.requirements"
                  ref="requirements"
                  @change="onEditorChangeRequirements($event)"
              >
              </quill-editor>
            </v-col>
          </v-row>

          <v-card class="mx-3" elevation="0" style="border: 1px solid #9c9c9c">
            <v-card-title>
              <strong>Suas habilidades ao final do curso</strong>
            </v-card-title>

            <v-row
                cols="12" class="ma-0"
                v-for="(skillAcquired, index) in skillsAcquired"
                :key="index"

            >
              <v-col ccols="12" xs="12" sm="12" md="12" lg="5" xl="5">
                <label>Título</label>
                <v-text-field
                    outlined
                    hide-details
                    placeholder="Digite o título"
                    v-model="skillAcquired.title"
                    attach
                    dense
                    :rules="[rules.required]"
                    color="#000000"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <label>Descrição</label>
                <v-text-field
                    outlined
                    hide-details
                    placeholder="Digite a descrição"
                    v-model="skillAcquired.description"
                    attach
                    dense
                    :rules="[rules.required]"
                    color="#000000"
                >
                </v-text-field>
              </v-col>
              <v-col align-self="end" justify="end" cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
                <section class="d-flex-row align-center flex-nowrap" style="min-width: max-content">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          outlined
                          fab
                          tile
                          style="border-radius: 4px"
                          width="35"
                          height="35"
                          small
                          class="ma-1 quinary-button"
                          color="quaternary"
                          @click="addSkillAcquired()"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          outlined
                          fab
                          tile
                          style="border-radius: 4px"
                          width="35"
                          height="35"
                          small
                          class="ma-1 remove-button"
                          color="red"
                          @click="removeSkillAcquired(index)"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon dark>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </section>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="mx-3" elevation="0" style="border: 1px solid #9c9c9c">
            <v-card-title>
              <strong>Este curso é para você que:</strong>
            </v-card-title>

            <v-row
                cols="12" class="ma-0"
                v-for="(targetAudience, index) in targetAudiences"
                :key="index"
            >
              <v-col ccols="12" xs="12" sm="12" md="12" lg="5" xl="5">
                <label>Título</label>
                <v-text-field
                    outlined
                    hide-details
                    placeholder="Digite o título"
                    v-model="targetAudience.title"
                    attach
                    dense
                    :rules="[rules.required]"
                    color="#000000"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <label>Descrição</label>
                <v-text-field
                    outlined
                    hide-details
                    placeholder="Digite a descrição"
                    v-model="targetAudience.description"
                    attach
                    dense
                    :rules="[rules.required]"
                    color="#000000"
                >
                </v-text-field>
              </v-col>
              <v-col align-self="end" justify="end" cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
                <section class="d-flex-row align-center flex-nowrap" style="min-width: max-content">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          outlined
                          fab
                          tile
                          style="border-radius: 4px"
                          width="35"
                          height="35"
                          small
                          class="ma-1 quinary-button"
                          color="quaternary"
                          @click="addTargetAudience()"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          outlined
                          fab
                          tile
                          style="border-radius: 4px"
                          width="35"
                          height="35"
                          small
                          class="ma-1 remove-button"
                          color="red"
                          @click="removeTargetAudience(index)"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon dark>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </section>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="mx-3" elevation="0" style="border: 1px solid #9c9c9c">
            <v-card-title>
              <strong>Conteúdo programático</strong>
            </v-card-title>

            <v-row
                cols="12" class="ma-0"
                v-for="(contentProgrammatic, index) in contentsProgrammatic"
                :key="index"
            >
              <v-col ccols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label>Título</label>
                <v-text-field
                    outlined
                    hide-details
                    placeholder="Digite o título"
                    v-model="contentProgrammatic.title"
                    attach
                    dense
                    :rules="[rules.required]"
                    color="#000000"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label>Descrição</label>
                <quill-editor
                    :content="contentProgrammatic.description"
                    :ref="`${index}_contentProgrammatic_description`"
                    @change="onEditorContentProgrammatic($event, index)"
                >
                </quill-editor>
              </v-col>
              <v-col align-self="end" justify="end" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <section class="d-flex-row align-center flex-nowrap" style="min-width: max-content">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          outlined
                          fab
                          tile
                          style="border-radius: 4px"
                          width="35"
                          height="35"
                          small
                          class="ma-1 quinary-button"
                          color="quaternary"
                          @click="addContentsProgrammatic()"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          outlined
                          fab
                          tile
                          style="border-radius: 4px"
                          width="35"
                          height="35"
                          small
                          class="ma-1 remove-button"
                          color="red"
                          @click="removeContentsProgrammatic(index)"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon dark>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </section>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="mx-3" elevation="0" style="border: 1px solid #9c9c9c">
            <v-card-title>
              <strong>Tags</strong>
            </v-card-title>

            <v-row align="end" cols="12" class="ma-0">
              <v-col ccols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                <label>Tag</label>
                <v-text-field
                    outlined
                    v-model="tag"
                    hide-details
                    placeholder="Digite a tag do curso"
                    attach
                    dense
                    color="#000000"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <v-btn
                    fab
                    tile
                    height="40"
                    width="100%"
                    style="border-radius: 6px;"
                    small
                    elevation="0"
                    :disabled="!tag"
                    @click="addTag()"
                    color="#bc0000"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>

              <v-col class="pa-3" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="tags && tags.length > 0">
                <section style="border: 1px solid #9c9c9c">
                  <v-chip
                      v-for="tag in tags"
                      :key="tag"
                      class="ma-2"
                      close
                      color="#bc0000"
                      text-color="white"
                      @click:close="deleteTag(tag)"
                  >
                    <span style="font-size: 14px">
                      {{ tag }}
                    </span>
                  </v-chip>
                </section>
              </v-col>
            </v-row>
          </v-card>

          <v-row class="d-flex justify-center pt-0 ma-0 pa-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <label>Ativo?</label>
              <v-select
                  color="black"
                  v-model="course.active"
                  :items="active"
                  outlined
                  append-icon="mdi-chevron-down"
                  required
                  placeholder="Ativo?"
                  dense
                  item-text="name"
                  item-value="value"
                  :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <label>Carga Horaria</label>
              <v-text-field
                  outlined
                  placeholder="Carga Horaria"
                  v-model="course.totalHours"
                  attach
                  dense
                  clearable
                  :rules="[rules.required]"
                  color="#000000"
                  type="number"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <label>Preço</label>
              <vuetify-money
                  :id="course.price"
                  color="black"
                  v-bind:outlined="outlined"
                  placeholder="0.00"
                  required
                  :rules="[rules.required]"
                  hide-details
                  dense
                  v-model="course.price"
                  v-bind:options="options"
                  style="border: 1px solid #979797; border-radius: 7.5px"
              ></vuetify-money>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center pt-0 ma-0 pa-0">
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <v-btn
                  elevation="0"
                  class="secondary-button"
                  width="100%"
                  @click="goToRoute('/cursos')"
              >
                <span>Voltar</span>
              </v-btn>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <v-btn
                  elevation="0"
                  class="primary-button"
                  width="100%"
                  @click="submit()"
              >
                <span v-if="courseId">Editar curso</span>
                <span v-else>Cadastrar curso</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderOrders from "@/views/pages/Orders/components/HeaderOrders.vue";
import Vue from "vue";
import draggable from 'vuedraggable'
import Utils from "@/Utils/FormatDate";

export default {
  name: "Course",
  components: {
    HeaderOrders,
    draggable
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    dragOptionsVideos() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },

  props: {},

  created() {
  },

  async mounted() {
    this.courseId = null
    const {courseId} = this.$route.query
    this.courseId = courseId
    this.course = {
      images: [],
      videos: [],
      name: null,
      description: null,
      period: null,
      level: null,
      price: 0.00,
      active: null,
      totalHours: 0,
      aboutTheCourse: null, // Sobre o Curso
      skillsAcquired: [], // Suas habilidades ao final do curso
      targetAudiences: [], // Este curso é para você que
      contentsProgrammatic: [], // Conteúdo programático
      requirements: null, // Pré-requisitos
      categoriesCourses: [], // Pré-requisitos
      tags: [], // Pré-requisitos
      image: null
    }
    this.skillsAcquired = [{
      title: null,
      description: null
    }] // Suas habilidades ao final do curso
    this.targetAudiences = [{
      title: null,
      description: null
    }] // Este curso é para você que
    this.contentsProgrammatic = [{
      title: null,
      description: null
    }] // Este curso é para você que
    this.tags = []
    this.categoriesCourses = []
    if (this.courseId) {
      await this.getCourse()
    }
    await this.getCategoryCourses()
  },
  data() {
    return {
      drag: false,
      dragVideo: false,
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
        max: 10
      },
      dialog: false,
      componentKey: 1,
      embeddedVideo: null,
      showVideos: true,
      dialogvideo: false,
      course: {
        images: [],
        videos: [],
        name: null,
        description: null,
        period: null,
        level: null,
        price: 0.00,
        active: null,
        totalHours: 0,
        aboutTheCourse: null, // Sobre o Curso
        skillsAcquired: [], // Suas habilidades ao final do curso
        targetAudiences: [], // Este curso é para você que
        contentsProgrammatic: [], // Conteúdo programático
        requirements: null, // Pré-requisitos
        categoriesCourses: [], // Pré-requisitos
        image: null, // Pré-requisitos
        tags: [], // Pré-requisitos
      },
      skillsAcquired: [{
        title: null,
        description: null
      }], // Suas habilidades ao final do curso
      targetAudiences: [{
        title: null,
        description: null
      }], // Este curso é para você que
      contentsProgrammatic: [{
        title: null,
        description: null
      }], // Este curso é para você que
      categoriesCourses: [],
      categoriesCoursesSelected: [],
      tags: [],
      tag: null,
      active: [
        {name: "Não", value: 'false'},
        {name: "Sim", value: true},
      ],
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: '1'},
        {name: "Noturno", value: '2'}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: '1'},
        {name: "Avançado", value: '2'}
      ],
      courseForm: false,
      courseId: null,
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    addVdeo() {
      try {
        this.showVideos = false
        if(!this.course.videos){
          this.course.videos = []
        }
        this.embeddedVideo = this.embeddedVideo
            .replace(/width="\d+"/, 'width="140"')
            .replace(/height="\d+"/, 'height="140"');
        this.course.videos.push(
            {
              htmlEmbed: this.embeddedVideo,
              uid: crypto.randomUUID(),
            }
        )
        console.log(this.course.videos)
        this.dialogvideo = false
        this.embeddedVideo = null
        this.showVideos = true
      } catch (e) {
        console.log(e)
      }
    },

    deleteVideo(uid){
      this.showVideos = false
      this.course.videos = this.course.videos.filter(v => v.uid !== uid)
      this.showVideos = true
    },

    showModalAddVideos() {
      this.embeddedVideo = null
      this.dialogvideo = true
    },

    deleteImage(uid) {
      try {
        this.course.images = this.course.images.filter(v => v.uid !== uid)
      } catch (e) {
        console.log(e)
      }
    },

    async setImage(images) {
      let sizeErrors = 0;
      for (let i = 0; i < images.length; i++) {
        if (images[i].size < 2097152) {
          const reader = new FileReader();
          reader.readAsDataURL(images[i]);
          reader.onload = () => {
            this.course.images.push({
              path: reader.result,
              uid: crypto.randomUUID(),
            });
          };
        } else {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: `A imagem '${images[i].name}' pode no máximo de 2MB!`,
            trace: null,
          });
        }
      }
    },

    openPicker() {
      document.querySelector("#imageInput").click();
    },

    async getCategoryCourses() {
      try {
        const {content} = await this.apiService.get(`categoryCourses`)
        this.categoriesCourses = content
      } catch (e) {

      }
    },

    async getCourse() {
      try {
        const {content} = await this.apiService.get(`course/${this.courseId}`,)
        this.course = content
        this.categoriesCoursesSelected = this.course.categoryCoursesToCourses && this.course.categoryCoursesToCourses.length > 0
            ? this.course.categoryCoursesToCourses.map((x) => x.categoryCoursesId)
            : []
        this.skillsAcquired = this.course.skillsAcquired && this.course.skillsAcquired.length > 0
            ? this.course.skillsAcquired
            : [{
              title: null,
              description: null
            }]
        this.targetAudiences = this.course.targetAudiences && this.course.targetAudiences.length > 0
            ? this.course.targetAudiences
            : [{
              title: null,
              description: null
            }]
        this.contentsProgrammatic = this.course.contentsProgrammatic && this.course.contentsProgrammatic.length > 0
            ? this.course.contentsProgrammatic
            : [{
              title: null,
              description: null
            }]
        this.tags = this.course.tags && this.course.tags.length > 0 ? this.course.tags.map(x => x.name) : []

        this.course.images = this.course.images && this.course.images.length > 0
            ? this.course.images.map((image) => {
                return {
                  ...image,
                  uid: crypto.randomUUID()
                }
              })
            : []

        this.course.videos = this.course.videos && this.course.videos.length > 0
            ? this.course.videos.map((image) => {
                return {
                  ...image,
                  uid: crypto.randomUUID()
                }
              })
            : []

      } catch (e) {

      }
    },

    async goToRoute(route) {
      await this.$router.push(route);
    },

    async submit() {
      try {
        const body = this.course
        if (!this.$refs.courseForm.validate()) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Preencha os campos corretamente",
            trace: null,
          });
          return
        }


        if (!this.course.price) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Informe o preço do curso!",
            trace: null,
          });
          return
        }

        if (!this.course.images || this.course.images <= 0) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Selecione a imagem da capa!",
            trace: null,
          });
          return
        }

        this.course.images.forEach((image, index) => {
          image.sort = index + 1
        })

        this.course.videos = this.course.videos && this.course.videos.length > 0
          ? this.course.videos.map((videos, index) => {
              return {
                ...videos,
                sort: index + 1
              }
            })
          : []
        console.log( this.course.videos)
        if (!this.categoriesCoursesSelected || this.categoriesCoursesSelected.length <= 0) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Selcione uma ou mais categorias/subcategorias!",
            trace: null,
          });
          return
        }

        body.categoriesCourses = this.categoriesCoursesSelected.map((x) => {
          return {
            id: x
          }
        })

        if (!this.skillsAcquired || this.skillsAcquired.length <= 0 || !!this.skillsAcquired.find((x) => !x.title || !x.description)) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Alguns campos não foram preenchidos corretamente. Confira e tente novamente!",
            trace: null,
          });
          return
        }
        body.skillsAcquired = this.skillsAcquired

        if (!this.targetAudiences || this.targetAudiences.length <= 0 || !!this.targetAudiences.find((x) => !x.title || !x.description)) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Alguns campos não foram preenchidos corretamente. Confira e tente novamente!",
            trace: null,
          });
          return
        }
        body.targetAudiences = this.targetAudiences

        if (!this.contentsProgrammatic || this.contentsProgrammatic.length <= 0 || !!this.contentsProgrammatic.find((x) => !x.title || !x.description)) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Alguns campos não foram preenchidos corretamente. Confira e tente novamente!",
            trace: null,
          });
          return
        }
        body.contentsProgrammatic = this.contentsProgrammatic
        body.tags = this.tags && this.tags.length > 0
            ? this.tags.map(x => {
              return {
                name: x.trim()
              }
            })
            : []

        let message = ''
        let statusCode = null
        if (this.courseId) {
          const response = await this.apiService.put(`course/${this.courseId}`, body, false)
          message = response.message
          statusCode = response.statusCode
        } else {
          const response = await this.apiService.post("course", body, false)
          message = response.message
          statusCode = response.statusCode
        }
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "success",
          title: message,
          message: message,
          trace: null,
        });
        if (statusCode == 200) {
          this.$refs.courseForm.reset()          // limpa todos os campos
          this.$refs.courseForm.resetValidation()
          this.courseId = null
          await this.goToRoute('/cursos')
        }

      } catch (e) {

      }
    },

    addSkillAcquired() {
      const find = this.skillsAcquired.find((x) => !x.title || !x.description);
      if (find) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Preencha os campos corretamente para adicionadar mais habilidades!",
          trace: null,
        });
        return
      }
      this.skillsAcquired.push(
          {
            title: null,
            description: null
          }
      )
    },

    removeSkillAcquired(index) {
      if (this.skillsAcquired.length >= 2) {
        this.skillsAcquired.splice(index, 1)
        return
      }
      Vue.$globalEvent.$emit("onFlashMessage", {
        type: "error",
        title: "",
        message: "É obrigatório ter uma ou mais habilidades!",
        trace: null,
      });
    },

    addTargetAudience() {
      const find = this.targetAudiences.find((x) => !x.title || !x.description);
      if (find) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Preencha os campos corretamente!",
          trace: null,
        });
        return
      }
      this.targetAudiences.push(
          {
            title: null,
            description: null
          }
      )
    },

    removeTargetAudience(index) {
      if (this.targetAudiences.length >= 2) {
        this.targetAudiences.splice(index, 1)
        return
      }
      Vue.$globalEvent.$emit("onFlashMessage", {
        type: "error",
        title: "",
        message: "É obrigatório ter uma ou mais!",
        trace: null,
      });
    },

    addContentsProgrammatic() {
      const find = this.contentsProgrammatic.find((x) => !x.title || !x.description);
      if (find) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Preencha os campos corretamente!",
          trace: null,
        });
        return
      }
      this.contentsProgrammatic.push(
          {
            title: null,
            description: null
          }
      )
    },

    removeContentsProgrammatic(index) {
      if (this.contentsProgrammatic.length >= 2) {
        this.contentsProgrammatic.splice(index, 1)
        return
      }
      Vue.$globalEvent.$emit("onFlashMessage", {
        type: "error",
        title: "",
        message: "É obrigatório ter uma ou mais conteúdo programático!",
        trace: null,
      });
    },

    addTag() {
      const tagAdd = this.tag.trim()
      const tag = this.tags.find((x) => x == tagAdd)
      if (tag) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Esta tag já foi adicionada!",
          trace: null,
        });
        return
      }
      this.tags.push(tagAdd)
      this.tag = null
    },
    deleteTag(tag) {
      const tagDelete = tag.trim()
      this.tags = this.tags.filter(t => t !== tagDelete)
    },
    onEditorChangeAboutTheCourse({quill, html, text}) {
      this.course.aboutTheCourse = html
    },

    onEditorChangeRequirements({quill, html, text}) {
      this.course.requirements = html
    },

    onEditorContentProgrammatic({quill, html, text}, index) {
      this.contentsProgrammatic[index].description = html
    }
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
#chartRecipeAndOrder {
  width: 100%;
}

#chartPaymentMethod {
  width: 100%;
}

.card-red {
  background: linear-gradient(to bottom, #f54784, #d62828);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

.card-black {
  background: linear-gradient(to bottom, #000000, #666666);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px 15px;
  text-align: left;
}

tr {
  cursor: pointer;
}

th {
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}

/* coluna receita */
td.receita {
  background: linear-gradient(to right, #f8d7da, #f5c6cb);
  text-align: left;
  font-weight: bold;
  color: #333;
}

/* coluna metros */
td.metros {
  background: linear-gradient(to right, #f8d7da, #f1b0b7);
  text-align: left;
  font-weight: bold;
  color: #333;
}

tr:nth-child(even) td {
  background-color: #fafafa;
}

.remove-button {
  border: 1px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}

.delete-photo {
  cursor: pointer;
  font-weight: normal;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 221px;
  height: 166px;

  background: #dadada;
  border-radius: 20px;

  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 10px !important;
}
.photo-field {
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}

.image-container {
  cursor: pointer;
  transition: 0.1s;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  border: 1px dashed #dadada;
  box-sizing: border-box;
  border-radius: 10px !important;
}

.main-image-field {
  font-weight: bold;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #e30011;
}

.image-field {
  font-weight: 300;
  font-size: 14px;
  line-height: 13px;
  letter-spacing: 0.15px;
  color: #979797;
  text-align: center;
}
.div-images {
  padding-bottom: 5px;
  overflow-x: scroll;
}

.div-images::-webkit-scrollbar {
  background-color: #fff;
  height: 10px;
  border-radius: 3.5px;
}

.div-images::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3.5px;
}

</style>
